import {inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {PaginatedResultModel} from "@core/model/paginated-result.model";
import {environment} from "@environment/environment";
import {HttpClient} from "@angular/common/http";
import {AuditLog} from "@core/model/audit-log";
import _ from "lodash";

@Injectable({providedIn: 'root'})
export class SecurityService {
  http: HttpClient = inject(HttpClient);


  public decodeJwt(token: string): any {
    try {
      const payload = token.split('.')[1];
      const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
      return JSON.parse(decoded);
    } catch (e) {
      return null;
    }
  }

  //API calls
  public getAudits(paramsObj: any): Observable<any> {
    const paramsObjCopy = _.cloneDeep(paramsObj);
    paramsObjCopy.startDate = paramsObjCopy.startDate ? new Date(paramsObjCopy.startDate).toISOString() : undefined;
    paramsObjCopy.endDate = paramsObjCopy.endDate ? new Date(paramsObjCopy.endDate).toISOString() : undefined;
    let params: any = {};
    Object.keys(paramsObjCopy).forEach(key => {
        if (paramsObjCopy[key] !== undefined && paramsObjCopy[key] !== 'undefined' && paramsObjCopy[key] !== null && paramsObjCopy[key] !== '') {
          params[key] = paramsObjCopy[key]?.value || paramsObjCopy[key];
        }
      }
    );
    return this.http.get(`${environment.auditUrl}/audits`, {
      responseType: 'json',
      params
    });
  }
}
